import { InferBaseHtmlType } from '@/components/ui/utils';
import React from 'react';
import { useToggle } from 'usehooks-ts';
import { TappIcon } from '../TappIcon';
import { TappInput, TappInputProps } from '../TappInput/Input';

type BaseType = Omit<React.ComponentProps<"input">, 'prefix'>;
export type TappPasswordProps = Omit<TappInputProps, 'type' | 'suffix' | 'ref'>;

const TappPasswordInput = React.forwardRef<InferBaseHtmlType<BaseType>, TappInputProps>(
  ({ ...props }, forwardedRef) => {
    const [isVisible, toggleIsVisible] = useToggle(false);

    return (
      <TappInput
        ref={forwardedRef}
        type={isVisible ? 'text' : 'password'}
        suffix={
          <button type="button" className="flex items-center justify-center leading-none" onClick={toggleIsVisible}>
            <TappIcon>{isVisible ? 'visibility_off' : 'visibility'}</TappIcon>
          </button>
        }
        {...props}
      />
    );
  }
);

TappPasswordInput.displayName = 'TappPasswordInput';
export { TappPasswordInput };
